import { FaTimes } from 'react-icons/fa';

function Modal({ isOpen, onClose, showClose = true, children }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        {showClose && (
          <button className="modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        )}
        {children}
      </div>
    </div>
  );
}

export default Modal;
